import React, { useEffect, useState } from "react";
import Helmet from "react-helmet";
import MobileNav from "./mobile-nav";
import SearchPopup from "./search-popup";

import AppleTouch from "../assets/images/favicons/apple-touch-icon.png";
import Fevicon32 from "../assets/images/favicons/32x32.png";
import Fevicon16 from "../assets/images/favicons/16x16.png";

import "bootstrap/dist/css/bootstrap.min.css";
import "swiper/swiper-bundle.min.css";
import "react-modal-video/css/modal-video.min.css";
import "../assets/css/animate.min.css";
import "../assets/css/azino-icons.css";
import "../assets/css/fontawesome-all.min.css";
import "../assets/css/main.css";
import "swiper/swiper-bundle.min.css";

const Layout = ({ pageTitle, children }) => {
  const [hasMounted, setHasMounted] = useState(false);
  const handleRadius = () => {
    const dynamicRadius = document.querySelectorAll(".dynamic-radius");
    dynamicRadius.forEach(function (btn) {
      let btnHeight = btn.offsetHeight;
      btn.style.borderBottomLeftRadius = btnHeight / 2 + "px";
      btn.style.borderTopLeftRadius = btnHeight / 2 + "px";
    });
  };

  useEffect(() => {
    if (typeof window !== "undefined") {
      handleRadius();
      setHasMounted(true);
      return () => {
        handleRadius();
      };
    }
  }, [hasMounted]);

  if (!hasMounted) {
    return null;
  }
  return (
    <div>
      <Helmet>
        <meta name="viewport" content="width=device-width, initial-scale=1.0" />
        <meta name="keywords" content="Charity, Donate, Nonprofit, Philanthropy, Fundraising, Support, Help, Humanitarian, Volunteer, Causes, Donations, Giving, Relief, Aid, Community, Kindness, Generosity, Social Impact, Campaign, Orphans, Food Bank, Education, Healthcare, Poverty, Shelter, Children, Environment, Water, Crisis, Disaster Relief, Advocacy, Sponsorship"/>
        <meta name="description" content="Love Foundation International (a.k.a Love in Deeds) is a nonprofit organization dedicated to transforming lives through acts of kindness, charity, and the love of Jesus Christ."/>
        <meta name="google-site-verification" content="LYpOGIog3JGm6HUbMRBVqdnCMHiVd2dIQpT9jZgnRdM" />


        <meta property="og:title" content="Charity, Donate,Support, Help, | Love Foundation International" />
        <meta property="og:description" content="Join us to make a difference in communities by supporting those in need with food, shelter, education, and hope." />
        <meta property="og:image" content={Fevicon32}/>
        <meta property="og:url" content="https://lovefoundationinternational.org/" />
        <meta property="og:type" content="website" />

        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:title" content="Charity, Donate,Support, Help, | Love Foundation International" />
        <meta name="twitter:description" content="Join us to make a difference in communities by supporting those in need with food, shelter, education, and hope." />
        <meta name="twitter:image" content={Fevicon32} />


        <title>{pageTitle}</title>
        <link rel="apple-touch-icon" sizes="180x180" href={AppleTouch} />
        <link rel="icon" type="image/png" sizes="32x32" href={Fevicon32} />
        <link rel="icon" type="image/png" sizes="16x16" href={Fevicon16} />
        <link rel="canonical" href="/"/>
        <link
          href="https://fonts.googleapis.com/css2?family=Jost:ital,wght@0,100;0,200;0,300;0,400;0,500;0,600;0,700;0,800;0,900;1,100;1,200;1,300;1,400;1,500;1,600;1,700;1,800;1,900&family=Libre+Baskerville:ital,wght@0,400;0,700;1,400&display=swap"
          rel="stylesheet"
        />
      </Helmet>
      <div className="page-wrapper" id="wrapper">
        {children}
      </div>
      <MobileNav />
      <SearchPopup />
    </div>
  );
};

export default Layout;
